/**
 * @desc 根据采购比例审批单据NO获取比例分配详情
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.ResponseDto<defs.srm.SupplierPurchaseRatioResponseDto>;
export function request(ratioNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierQuotation/getPurchaseRatioByRatioNo/${ratioNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
